import LayoutAssinaturaEmbed from '../../componentes/LayoutAssinaturaEmbed.vue';
import Sessao from './componentes/Sessao.vue';
import Assinatura from '../pessoa-fisica/componentes/Assinatura.vue';
import AssinarDocumento from '../pessoa-fisica/componentes/AssinarDocumento.vue';
import DetalhesDocumentoAssinatura from '../pessoa-fisica/componentes/DetalhesDocumentoAssinatura.vue';

const PREFIXO_ROTA = 'assinatura-embed';

export default {
  path: '/assinatura-embed',
  component: LayoutAssinaturaEmbed,
  children: [
    {
      path: '',
      name: 'assinatura-embed.sessao',
      component: Sessao,
    },
    {
      path: 'lista',
      name: 'assinatura-embed',
      component: Assinatura,
      meta: { prefixoRotaAssinatura: PREFIXO_ROTA },
    },
    {
      path: 'assinar/:id',
      name: 'assinatura-embed.assinar',
      component: AssinarDocumento,
      meta: { prefixoRotaAssinatura: PREFIXO_ROTA },
    },
    {
      path: 'detalhes/:id',
      name: 'assinatura-embed.detalhes',
      component: DetalhesDocumentoAssinatura,
      meta: { prefixoRotaAssinatura: PREFIXO_ROTA },
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/assinatura-embed/rotas.js